// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
		//paginationType: boostPFSConfig.custom.endless_scroll ? 'infinite' : 'default',
		trackingProduct: '.boost-pfs-filter-products .product-item',
		trackingQuickView: '.trigger-quick-view ',
		trackingAddToCart: '.add-js.product__submit__add',
		trackingBuyNow: '.shopify-payment-button, #dynamic-checkout-cart',
      	filterTreeMobileStyle: 'style1'
	}
};

var isFirstLoad = true;

(function() {
	BoostPFS.inject(this);
  
	jQ('.boost-pfs-filter-tree-h').length > 0 ? boostPFSFilterConfig.general.separateRefineByFromFilter = true : boostPFSFilterConfig.general.separateRefineByFromFilter = false;
  
	ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
		if (!data) data = this.data;

		if (!index) index = this.index;
		if (!totalProduct) totalProduct = this.totalProduct;
		/*** Prepare data ***/
		var product = data;
		var images = data.images_info;
		var sold_out = !data.available; // Check a product is out of stock
		var on_sale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}

		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.product_grid_item_html;

		// variants_first_id
		itemHtml = itemHtml.replace(/{{variants_first_id}}/g, firstVariant.id);

		// grid_string
		itemHtml = itemHtml.replace(/{{grid_strings}}/g, boostPFSConfig.custom.grid_strings);
      
      	if (!boostPFSConfig.custom.product_grid_outline) {
          	itemHtml = itemHtml.replace(/{{border_class}}/g, 'product-item--borderless');
        } else {
        	itemHtml = itemHtml.replace(/{{border_class}}/g, '');
        }
      
      	if (boostPFSConfig.custom.product_grid_center) {
          	itemHtml = itemHtml.replace(/{{alignment_class}}/g, 'product-item--centered');
        } else {
        	itemHtml = itemHtml.replace(/{{alignment_class}}/g, '');
        }

        // gridWidthClass
        var products_per_row =  boostPFSConfig.custom.products_per_row;
        var grid_width_large = 'large-up--one-sixth';
        var grid_width_medium = 'medium--one-third';
        var grid_width_small = 'small--one-half';
        switch(products_per_row) {
          case 2:
            grid_width_large = 'large-up--one-half';
            grid_width_medium = 'medium--one-half';
            grid_width_small = 'small--one-half';
            break;
          case 3:
            grid_width_large = 'large-up--one-third';
            grid_width_medium = 'medium--one-third';
            grid_width_small = 'small--one-half';
            break;
          case 4:
            grid_width_large = 'large-up--one-quarter';
            grid_width_medium = 'medium--one-third';
            grid_width_small = 'small--one-half';
            break;
          case 5:
            grid_width_large = 'large-up--one-fifth';
            grid_width_medium = 'medium--one-third';
            grid_width_small = 'small--one-half';
            break;
        }
        itemHtml = itemHtml.replace(/{{grid_width_small}}/g, grid_width_small);
        itemHtml = itemHtml.replace(/{{grid_width_medium}}/g, grid_width_medium);
        itemHtml = itemHtml.replace(/{{grid_width_large}}/g, grid_width_large);

		// double__image_class
		var double_image_class = '',
			double_img_html = '';
		if (images.length > 1 && boostPFSConfig.custom.image_hover_enable) {
			double_image_class = 'double__image';
			 let hoverImage = images.find(img =>  (img.src.includes("-6_") || img.src.includes("-6.")))
			var bgset_image1 = hoverImage ? bgset(hoverImage) : bgset(images[1]);
			double_img_html = '<div class="product-item__bg__under lazyload" data-bgset="' + bgset_image1 + '"></div>';
		}
		itemHtml = itemHtml.replace(/{{double_image_class}}/g, double_image_class);
		itemHtml = itemHtml.replace(/{{double_img_html}}/g, double_img_html);

		// animation_delay_150
		var animation_delay_150 = '';
		var animation_delay = (1 % boostPFSConfig.custom.grid_int) * 1;
		var animation_delay_150 = animation_delay * 150;
		var animation_delay_duration_800 = animation_delay * 100 + 800;
		itemHtml = itemHtml.replace(/{{animation_delay_150}}/g, animation_delay_150);
		itemHtml = itemHtml.replace(/{{animation_delay_duration_800}}/g, animation_delay_duration_800);

		// bgset
        /* Boost - 217744 */
        var bgset_image0 = boostPFSConfig.general.no_image_url;
        if (images.length > 0) {
            let fifthImg = images.find(img => (img.src.includes("-5_") || img.src.includes("-5.")));
            bgset_image0 = fifthImg ? bgset(fifthImg) : bgset(images[0]);
        }
		// var bgset_image0 = images.length > 0 ? bgset(images[0]) : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{bgset_image0}}/g, bgset_image0);
         /* Boost - 217744 */

		// over_image_content_html
		var over_image_content_html = '';
		if (on_sale && boostPFSConfig.custom.hasOwnProperty('sale_tags_enable') && boostPFSConfig.custom.sale_tags_enable == true) {
			over_image_content_html += boostPFSTemplate.sale_label_html;
		}
		if (boostPFSConfig.custom.hasOwnProperty('quickview_enable') && boostPFSConfig.custom.quickview_enable == true) {
			over_image_content_html += boostPFSTemplate.quick_view_html;
		}
		itemHtml = itemHtml.replace(/{{over_image_content_html}}/g, over_image_content_html);

		var featured_media_url = images.length > 0 ? Utils.optimizeImage(images[0].src, '540x') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{featured_media_url}}/g, featured_media_url);

		var animation_delay_100 = animation_delay * 100;
		var animation_delay_duration_100 = animation_delay * 100 + 100;
		itemHtml = itemHtml.replace(/{{itemAnimationDelay}}/g, animation_delay_100);
		itemHtml = itemHtml.replace(/{{itemAnimationDuration}}/g, animation_delay_duration_100);

		// reviews_html
		itemHtml = itemHtml.replace(/{{reviews_html}}/g, boostPFSTemplate.reviews_html);

		// sale_class
		var sale_class = '';
		if (on_sale) {
			sale_class = 'sale';
		}
		itemHtml = itemHtml.replace(/{{itemSaleClass}}/g, sale_class);

		// price_html
		var price_html = '';
		if (!sold_out) {
			if (on_sale) {
				price_html += '<span class="old-price">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '</span>\n';
			}
			if (priceVaries) {
				price_html += boostPFSTemplate.from_label_html + '\n';
				price_html += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			} else {
				price_html += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			}
		} else {
			price_html += boostPFSTemplate.soldout_label_html;
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, price_html);

		var show_reviews = false;
		var itemQuickviewHtml = '';
		if (boostPFSConfig.custom.quickview_enable) {
			show_reviews = false;
			itemQuickviewHtml = boostPFSTemplate.quick_view_html;
			if (boostPFSConfig.custom.enable_yotpo && boostPFSConfig.custom.yotpo_ID !== '') {
				show_reviews = true;
			} else if (boostPFSConfig.custom.enable_product_reviews) {
				show_reviews = true;
			}
		}
		itemHtml = itemHtml.replace(/{{itemQuickview}}/g, itemQuickviewHtml);
		itemHtml = itemHtml.replace(/{{show_reviews}}/g, show_reviews);

		itemHtml = itemHtml.replace(/{{ariaLabelQuickView}}/g, boostPFSConfig.label.quick_close + ' ' + boostPFSConfig.label.quick_view);
		itemHtml = itemHtml.replace(/{{enable_zoom}}/g, boostPFSConfig.custom.enable_zoom);
		itemHtml - itemHtml.replace(/{{enable_video_looping}}/g, boostPFSConfig.custom.enable_video_looping);

      	// Start Boost 201050
      	/* Swym integration */
        // var itemWishlistHtml = '<button data-with-epi="true" class="wishlist_btn swym-button swym-add-to-wishlist-view-product product_' + data.id + '" data-swaction="addToWishlist" data-product-id="' + JSON.stringify(data.id) + '" data-variant-id="' + data.variants[0].id + '" data-product-url="' + boostPFSConfig.shop.url + Utils.buildProductItemUrl(data, false) + '"></button>';
        // itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

        /* Swym integration */
        var itemWishlistHtml = '<button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product wishlist swym-button product_' + data.id + '" data-swaction="addToWishlist" data-product-id="' + JSON.stringify(data.id) + '" data-variant-id="' + data.variants[0].id + '" data-product-url="' + boostPFSConfig.shop.url + Utils.buildProductItemUrl(data, false) + '"></button>';
        itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);
        // End Boost 201050
		

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
      	itemHtml = itemHtml.replace(/{{itemVariantId}}/g, data.variants[0].id);
      	itemHtml = itemHtml.replace(/{{itemType}}/g, data.product_type);
      
      	itemHtml = itemHtml.replace(/{{itemIndex}}/g, this.index);
      	itemHtml = itemHtml.replace(/{{itemCurrentPage}}/g, Globals.queryParams.page);
      
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
      
      	var itemCustomTitle = '';
      	if (Utils.getProductMetafield(data, 'global', 'additional_title')) {
          itemCustomTitle = '<p class="product-additional-title text-line">' + Utils.getProductMetafield(data, 'global', 'additional_title') + '</p>';
        } else {
          itemCustomTitle = '<p class="product-additional-title text-line no-additional-title"></p>';
        }
      	itemHtml = itemHtml.replace(/{{itemCustomTitle}}/g, itemCustomTitle);

		// itemHtml = itemHtml.replace(/{{my_swatch_buttons}}/g, my_swatch_buttons);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));	

		return itemHtml;
	};

	function bgset(image) {
		var bgset = '';
		if (image) {
			var aspect_ratio = image.width / image.height;

			if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
			if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
			if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
			if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
			if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
			if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
			if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
			if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
			if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
			if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
			if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
			if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
			if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
			if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
			if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
			if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
			if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
			if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 4100x ' + Math.round(4100 / aspect_ratio) + 'h,';
			bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
		}
		return bgset;
	}

	function matchColors(colors, name) {
		let bg = '#E5E5E5';
		let img = null;
		const path = window.theme.assets.base || '/';
		const comparisonName = name.toLowerCase().replace(/\s/g, '');
		const array = colors.colors;
  
		if (array) {
		  let indexArray = null;
  
		  const hexColorArr = array.filter((colorObj, index) => {
			const neatName = Object.keys(colorObj).toString().toLowerCase().replace(/\s/g, '');
  
			if (neatName === comparisonName) {
			  indexArray = index;
  
			  return colorObj;
			}
		  });
  
		  if (hexColorArr.length && indexArray !== null) {
			const value = Object.values(array[indexArray])[0];
			bg = value;
  
			if (value.includes('.jpg') || value.includes('.jpeg') || value.includes('.png') || value.includes('.svg')) {
			  img = `${path}${value}`;
			  bg = '#888888';
			}
		  }
		}
  
		return {
		  color: name,
		  path: img,
		  hex: bg,
		};
	  }

	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		var html = "";
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = currentPage > 1 ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift("...");
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push("...");
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = "";
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == "...") {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += pageArr[iPage] == currentPage ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, pageArr[iPage]));
			}
			html = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		}

		return html;
	};

	ProductPaginationLoadMore.prototype.compileTotalTemplate = function() {
		/**
		 * If enable the Load previous feature and the evnet type is page:
		 * => Get the next loading page is from session storage OR get the next loading page from query param
		 */
		if (Utils.isLoadPreviousPagePaginationType() && this.parent.eventType == 'page') {
			this.nextPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentNextPage));
		} else {
			this.nextPage = Globals.queryParams.page;
		}
		// Set from index
		var from = (this.nextPage - 1) * Globals.queryParams.limit + 1;
		var numberOfShowingProducts = jQ(Selector.products + ' > .product-item').length;
		if (numberOfShowingProducts) {
			from -= numberOfShowingProducts - Globals.queryParams.limit;
		}
		// Set to index
		var product_index = (this.nextPage - 1) * Globals.queryParams.limit + 1;
		var to = product_index + this.data.products.length - 1;
		this.toProduct = to;

		return this.getTemplate('total')
			.replace(/{{progressLabel}}/g, Labels.loadMoreTotal)
			.replace(/{{ from }}/g, from)
			.replace(/{{ to }}/g, to)
			.replace(/{{ total }}/g, this.totalProduct)
			.replace(/{{class.productLoadMore}}/g, Class.productLoadMore)
	}

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
			var sortingArr = Utils.getSortingList();
			var current_sort_param = Globals.queryParams.sort || boostPFSConfig.general.default_sort_by;
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = "";

				for (var k in sortingArr) {
					var active_class = '',
						aria_current_attr = '';
					if (current_sort_param == k) {
						active_class = ' popout-list__item--current';
						aria_current_attr = 'aria-current="true" ';
					}
					sortingItemsHtml += '<li class="popout-list__item ' + active_class + '">' +
						'<a class="popout-list__option" ' +
						'data-value="' + k + '" ' +
						'data-sort-title="' + sortingArr[k] + '" ' +
						'href="#" ' +
						aria_current_attr +
						'data-sort-link>' +
						'<span>' + sortingArr[k] + '</span>' +
						'</a>' +
						'</li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);

			}
		}
		return html;
	};

	ProductSorting.prototype.render = function() {
		jQ(Selector.topSorting).html(this.compileTemplate());
	};

	/**
	 * Bind the events on Sorting select box
	 */
	ProductSorting.prototype.bindEvents = function() {
		jQ(Selector.topSorting).find('li').click(function(event) {
          	event.preventDefault();
			jQ(this).siblings('li').removeClass('popout-list__item--current');
			jQ(this).addClass('popout-list__item--current');
			// Append "sort" param to url
			// Used to Scroll to the previous position after returning from Product page
			FilterApi.setParam('sort', jQ(this).find('a').data('value'));
			var current_sort_title = jQ(this).find('a').data('sort-title');
			jQ('.boost-pfs-top-sorting-current-value').text(current_sort_title);
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
          	jQ('.boost-pfs-top-sorting-current-value').trigger('click');
		})
	};

	var timeOut = null;
	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
		// Call function to get extra product html by ajax
		var outerCollection = document.querySelector('[data-section-type="collection"]');
		var outerSearch = document.querySelector('[data-section-type="search"]');

		if (typeof Shopify.theme != 'undefined' &&
			typeof Shopify.theme.sections != 'undefined' &&
			typeof Shopify.theme.sections.registered != 'undefined' &&
			typeof Shopify.theme.sections.registered['product-grid'] == 'function') {
			clearTimeout(timeOut);
			timeOut = setTimeout(function() {
				if (Utils.isSearchPage()) {
					if (outerSearch) {
						Shopify.theme.sections.registered['product-grid'](outerSearch);
					}
				} else {
					if (outerCollection) {
						Shopify.theme.sections.registered['product-grid'](outerCollection);
					}
				}
			}, 200);
		}
      
      	/** Start Swym integration **/
        // window.SwymCallbacks = window.SwymCallbacks || [];
        // window.SwymCallbacks.push(function(swat) { 
        //     // Wrap with callback for loading without additional checks
        //     var products = [];
        //     data.forEach(function(product) {
        //         var image_src = Utils.getFeaturedImage(product.images_info);
        //         var productCopy = product;
        //         productCopy.featured_image = image_src;
        //         productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
        //         productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
        //         products.push(productCopy);
        //     });
        //     swat.mapShopifyProducts(products); // Product mapped data to swym layer
        //     swat.initializeActionButtons('.boost-pfs-filter-products'); // Buttons can now be initialized
        // });
        /** End Swym integration **/

        var ajxCount = 0;
          for (var _product of data) {
              console.log(_product)
              let productHandleAjax = Shopify.routes.root + 'products/'+ _product.handle +'?view=boost-pfs-custom-integration';
              let requestReg = formRequest(productHandleAjax);
                  requestReg.then((res_success) => {
                      try {
                          let parse_res_success = JSON.parse(res_success);
                          console.log({parse_res_success})
                          jQ('.modal__outer[data-id="' + parse_res_success.id + '"]').html(parse_res_success.quickview);
                      } catch(error) {
                          console.log(error)
                      }
                  }).catch((res_error) => {
                          console.log(res_error)
                  }).finally(() => {
                      ajxCount = ajxCount + 1;
                      // re-init theme functions
                      if (ajxCount === data.length) {
                          initQuickview();
                      }
      
                  });
          }

        // Start Boost 201050
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
		
        // this.buildExtrasProductListByAjax(data, 'boost-pfs-quickview', function(results) {
        //   results.forEach(function(result, index) {
        //     jQ('.modal__outer[data-id="' + result.id + '"]').html(result.quickview);
        //     if(index == results.length - 1){
        //       initQuickview();
        //     }
        //   });
        // });
	};

    function formRequest(value) {
        return new Promise((resolve, reject) => {
            var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
            xhr.open("GET", value);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.onload = () => resolve(xhr.responseText);
            xhr.onerror = () => reject(xhr.statusText);
            xhr.send();
        });
    }

    FilterOption.prototype.afterRender = function() {
      setTimeout(() => {
        jQ(this.$element).find('.noUi-value.noUi-value-horizontal.noUi-value-large').each(function() {
          var value = jQ(this).text();
          value = Math.ceil(value/5)*5;
          jQ(this).text(value);
        })
      }, 500)
    }
	
	// Build additional elements
	FilterResult.prototype.afterRender = function(data) {
		if (!data) data = this.data;

        // Start-Boost-188200
        if(typeof(between_image) !== 'undefined'){
          var image_between_position = Number(between_image.position);
          var image_between_pageshow = 1;
          var image_between_current_page = 1;
          var current_page = (Utils.getParam('page') !== null) ? parseInt(Utils.getParam('page')) : 1;

          if(image_between_position > boostPFSConfig.custom.products_per_page){
            image_between_position = image_between_position % boostPFSConfig.custom.products_per_page;
            image_between_pageshow = Math.ceil(Number(between_image.position) / boostPFSConfig.custom.products_per_page);
          }
          
          if(image_between_position > 0 && current_page == image_between_pageshow){
            var image_between_html = `
              <div class="image-between-container row-four">
                <div class="image-between-product-container is-both-side">{{between_left}}</div>
                <div class="image-between">
                    <div loading="lazy" class="image-between-bg" data-bgset="" style="height: 626px; background-image: url(https://`+ Shopify.shop +`/cdn/shop/files/`+ between_image.image +`);"></div>
                    <div class="image-between-content" style="height: 152px;">
                        <h2 class="text-subheadline">`+ between_image.headline +`</h2>
                        <a class="element-links" href="https://`+ Shopify.shop +`/`+ between_image.link_path + `">
                          `+ between_image.link_text +`
                          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-select" viewBox="0 0 38 20"><path d="M19.351 15.932L35.457.466A1.35 1.35 0 0136.495 0c.41 0 .77.155 1.081.466.283.283.424.629.424 1.038 0 .41-.141.756-.424 1.038L20.411 19.534c-.283.31-.636.466-1.06.466-.423 0-.777-.155-1.06-.466L1.128 2.542a1.412 1.412 0 01-.424-1.038c0-.41.141-.755.424-1.038C1.409.156 1.762 0 2.187 0c.423 0 .776.155 1.059.466L19.35 15.932z" fill="#726D75" fill-rule="nonzero"></path></svg>
                        </a>
                    </div>
                </div>
                <div class="image-between-product-container is-both-side">{{between_right}}</div>
              </div>
            `;
            var image_between_left = '';
            var image_between_right = '';
            var bwCounter = 0;
            
            jQ(".boost-pfs-filter-products > .product-item").each(function(e){
              bwCounter++;
              if(bwCounter == image_between_position - 1 || bwCounter == image_between_position){
                image_between_left += jQ(this)[0].outerHTML;
              }
              if(bwCounter == image_between_position + 1 || bwCounter == image_between_position + 2){
                image_between_right += jQ(this)[0].outerHTML;
              }
            });
          
            image_between_html = image_between_html.replace(/{{between_left}}/g, image_between_left);
            image_between_html = image_between_html.replace(/{{between_right}}/g, image_between_right);
    
            var bwCounterSc = 0;
            jQ(".boost-pfs-filter-products > .product-item").each(function(e){
              bwCounterSc++;
              if(bwCounterSc == 8){
                jQ(this).after(image_between_html);
              }
              if(bwCounterSc == image_between_position - 1 || bwCounterSc == image_between_position || bwCounterSc == image_between_position + 1 || bwCounterSc == image_between_position + 2){
                jQ(this).remove();
              }
            });
          }
        }
      // End-Boost-188200
      
	};
  
  	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;
      
      	// Event for sorting in search page
//         if (Utils.isSearchPage()) {
//             jQ('.boost-pfs-top-sorting-current-value').click(function(event) {
//                 jQ(Selector.topSorting).toggleClass('popout-list--visible');
//             })
//             jQ(document).on('click', function (e) {
//                 if (jQ(e.target).closest(".boost-pfs-top-sorting-current-value").length == 0) {
//                     jQ(Selector.topSorting).removeClass('popout-list--visible');
//                 }
//             });
//         }
      
      	// console.log
      	jQ('body').addClass('boost-pfs-filter-tree-open-body');
	};
})();

function initQuickview() {
  $('.modal__overlay.quicklook').each(function () {
    
    var quicklookModal = new quicklook($(this));
    quicklookModal.init();
    var $quicklook = $(this);
    var variants = JSON.parse($quicklook.find('[data-product-variants-json]').html());
    var firstVariant = variants[0];
    if (firstVariant.available) {
      $quicklook.find('[data-shipping-status-available]').removeClass('hidden');
      $quicklook.find('[data-shipping-status-unavailable]').addClass('hidden');
      $quicklook.find('[data-add-to-cart]').prop('disabled', false);
      $quicklook.find('[data-add-to-cart-text]').html(theme.strings.addToCart + theme.icons.arrowRight);
    } else {
      $quicklook.find('[data-shipping-status-available]').addClass('hidden');
      $quicklook.find('[data-shipping-status-unavailable]').removeClass('hidden');
      $quicklook.find('[data-add-to-cart]').prop('disabled', true);
      $quicklook.find('[data-add-to-cart-text]').html(theme.strings.soldOut + theme.icons.arrowRight);
    }

    var imageGallery = {
      init: function() {
        this.init = this.init.bind(this);
        this.initGalleryMain = this.initGalleryMain.bind(this);
        this.initGalleryThumbs = this.initGalleryThumbs.bind(this);
        this.update = this.update.bind(this);
        this.emptySlides = this.emptySlides.bind(this);
        this.appendSlides = this.appendSlides.bind(this);
        this.variantChange = this.variantChange.bind(this);
        this.initGalleryThumbs();
        this.initGalleryMain();
        try {
          this.product = JSON.parse($quicklook.find('[data-product-json]').html());
          this.galleryJSON = JSON.parse($quicklook.find('[data-product-gallery-json]').html());
          this.currentVariantId = this.product.variants[0].id;
          this.currentVariantSku = this.product.variants[0].sku;
        } catch (error) {
          console.log(error);
        }
        if (this.galleryJSON && this.galleryJSON.length) {
          this.appendSlides();
        }
      },
      initGalleryMain: function() {
        
        this.galleryMain = new Swiper($quicklook.find('.swiper-container.gallery-main')[0], {
          direction: 'horizontal',
          loop: false,
          autoplay: false,
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          freeMode: false,
          preloadImages: false,
          lazy: true,
          thumbs: {
            swiper: this.galleryThumbs
          }
        });
      },
      initGalleryThumbs: function() {
        this.galleryThumbs = new Swiper($quicklook.find('.gallery-thumbs')[0], {
          direction: 'horizontal',
          loop: false,
          autoplay: false,
          slidesPerView: 5,
          slidesPerGroup: 1,
          freeMode: false,
          spaceBetween: 10,
          direction: 'horizontal',
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          allowTouchMove: false,
          preloadImages: false,
          lazy: true
        });
      },
      update: function() {
        if (this.galleryMain) {
          this.galleryMain.update();
        }
        if (this.galleryThumbs) {
          this.galleryThumbs.slideReset();
          this.galleryThumbs.update();
        }
      },
      emptySlides: function() {
        if (this.galleryMain) {
          this.galleryMain.removeAllSlides();
        }
        if (this.galleryThumbs) {
          this.galleryThumbs.removeAllSlides();
        }
      },
      appendSlides: function() {
        var _this = this, imageSlides;
        if (this.galleryMain && this.galleryThumbs) {
          imageSlides = this.galleryJSON.filter(function(image) {
            return image.filename.includes(_this.currentVariantSku);
          });
          if (imageSlides && imageSlides.length) {
            imageSlides.forEach(function(imageSlide, i) {
              var active = '';
              if (i == 0) {
                active = 'swiper-slide-thumb-active';
              }
              var is_image_2 = false;
              if (imageSlide.thumb.includes('-2_') || imageSlide.thumb.includes('-2.')) {
                is_image_2 = true;
              }
              if (!is_image_2) {
                _this.galleryThumbs.appendSlide('<div class="swiper-slide ' + active + '"><img class="swiper-lazy" style="width: 100%; height: auto;" data-src="' + imageSlide.thumb + '"><div class="swiper-lazy-preloader"></div></div>');
              }
              _this.galleryMain.appendSlide('<div class="swiper-slide"><img class="swiper-lazy" style="width: 100%; height: auto;" data-src="' + imageSlide.img + '"><div class="swiper-lazy-preloader"></div></div>');
            });
          }
        }
      },
      variantChange: function(variantId, variantSku) {
        this.currentVariantId = variantId;
        this.currentVariantSku = variantSku;
        this.emptySlides();
        this.appendSlides();
      }
    }

    imageGallery.init();

    $(document).on('click', '.trigger-quick-view', function(e) {
      e.preventDefault();
      imageGallery.update();
    });

    $quicklook.find('.color-swatch .thumb--image').each(function() {
      $(this).click(function(e) {
        e.preventDefault();
        if (!$(this).is('.selected')) {
          var variantId = $(this).data().variantId;
          var variantSku = $(this).data().variantSku;
          var currentVariant = JSON.parse($quicklook.find('[data-product-variants-json]').html());
          currentVariant = currentVariant.find(function(variant) {
            return variant.id == variantId;
          });
          $quicklook.find('.product-sku').html(variantSku);
          imageGallery.variantChange(variantId, variantSku);
          $('.color-swatch .thumb--image.selected').removeClass('selected');
          $(this).addClass('selected');
          if (currentVariant.available) {
            $quicklook.find('[data-shipping-status-available]').removeClass('hidden');
            $quicklook.find('[data-shipping-status-unavailable]').addClass('hidden');
            $quicklook.find('[data-add-to-cart]').prop('disabled', false);
            $quicklook.find('[data-add-to-cart-text]').html(theme.strings.addToCart + theme.icons.arrowRight);
          } else {
            $quicklook.find('[data-shipping-status-available]').addClass('hidden');
            $quicklook.find('[data-shipping-status-unavailable]').removeClass('hidden');
            $quicklook.find('[data-add-to-cart]').prop('disabled', true);
            $quicklook.find('[data-add-to-cart-text]').html(theme.strings.soldOut + theme.icons.arrowRight);
          }
        }
      });
    });
  });
}